export default __webpack_public_path__ + "static/media/icons8-cooker-hood.cb693e60.svg";